import React, { useState, useEffect, useMemo } from "react"
import { Table, Row, Col, Pagination, PaginationItem, PaginationLink } from "reactstrap"

const apiUrl = "https://balance.idexo.io"

const CreditsTable = (props) => {
    const { data } = props

    const countPerPage = 5
    const [currentPageIndex, setCurrentPageIndex] = useState(0)
    const [historyOfCredits, setHistoryOfCredits] = useState(data)

    const getTwoDigits = (val) => (val < 10 ? `0${val}` : val)

    const formattedDateString = (date) => {
        const year = date.getFullYear()
        const month = getTwoDigits(date.getMonth() + 1)
        const day = getTwoDigits(date.getDate())

        return `${day}.${month}.${year}`
    }

    useEffect(() => {
        if (data) return

        fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            json: true
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    alert("Error: " + data.error)
                } else {
                    if (data.data && data.data.history) {
                        setHistoryOfCredits(data.data.history)
                    }
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])

    const totalPageCount = useMemo(() => {
        if (historyOfCredits && historyOfCredits["Items"].length) {
            return Math.ceil(historyOfCredits["Items"].length / countPerPage)
        }

        return 0
    }, [historyOfCredits])

    return (
        <>
            <div style={{ overflow: "auto" }}>
                <Table className="align-middle mb-0 table-nowrap">
                    <thead className="table-light">
                        <tr>
                            <th scope="col">No</th>
                            {/*<th scope="col">Computed Credits</th>*/}
                            <th scope="col">Paid Amount</th>
                            <th scope="col">Payment Methods</th>
                            <th scope="col">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {historyOfCredits &&
                            historyOfCredits["Items"] &&
                            historyOfCredits["Items"].length &&
                            historyOfCredits["Items"]
                                .slice(currentPageIndex * countPerPage, currentPageIndex * countPerPage + 5)
                                .map((data, index) => (
                                    <tr key={data.id}>
                                        <td>{index + 1 + currentPageIndex * countPerPage}</td>
                                        <td>${data.amount["N"]}</td>
                                        <td>{data.method["S"]}</td>
                                        <td>{formattedDateString(new Date(data.inserted["N"] * 1000))}</td>
                                    </tr>
                                ))}
                    </tbody>
                </Table>
            </div>
            <Row>
                <Col lg="12">
                    <Pagination className="pagination pagination-rounded justify-content-center mt-2">
                        <PaginationItem disabled={currentPageIndex === 0}>
                            <PaginationLink previous href="#" onClick={() => setCurrentPageIndex(0)} />
                        </PaginationItem>
                        {new Array(totalPageCount).fill(0).map((_, index) => (
                            <PaginationItem active={currentPageIndex === index} key={index}>
                                <PaginationLink href="#" onClick={() => setCurrentPageIndex(index)}>
                                    {index + 1}
                                </PaginationLink>
                            </PaginationItem>
                        ))}
                        <PaginationItem disabled={currentPageIndex + 1 === totalPageCount}>
                            <PaginationLink next href="#" onClick={() => setCurrentPageIndex(totalPageCount - 1)} />
                        </PaginationItem>
                    </Pagination>
                </Col>
            </Row>
        </>
    )
}

export default CreditsTable
